/**
 * Created by Kotkin on 27.06.2017.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import Button from 'components/button';
import { iconTypes } from 'components/icon';

import ComplaintModal from './complaint-modal';

import translates from './complaint-i18n.json';

import 'styles/base/subsys/complaint/_complaint.scss';

const bemClasses = new Bem('complaint');

@I18nHoc(translates)
class Complaint extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    // actionDoLogin: PropTypes.func,
    entity: PropTypes.string.isRequired,
    entityId: PropTypes.number.isRequired,
    closeDropDown: PropTypes.func,
    withIcon: PropTypes.bool,
    inListDD: PropTypes.bool, // props for dd
    dataView: PropTypes.string, // props dataView to button
    updateEvent: PropTypes.string,
    buttonTitle: PropTypes.string,
    buttonLabel: PropTypes.string,
    url: PropTypes.string,
    buttonIcon: PropTypes.string
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.openModal = this.openModal.bind(this);
    this.state = { renderModal: false };
    this.offset = null;
  }

  openModal(closeDD = false) {
    const { closeDropDown } = this.props;
    const { renderModal } = this.state;

    this.setState({ renderModal: !renderModal },
      () => { if (closeDD && !this.state.renderModal && closeDropDown) return closeDropDown(); }
    );
  }

  render() {
    const { i18n } = this;
    const {
      entity, entityId, withIcon, inListDD, dataView, className, updateEvent = '', url
    } = this.props;
    const buttonTitle = this.props.buttonTitle || i18n('complaintMainText');
    const buttonLabel = this.props.buttonLabel || i18n('complaintMainText');
    const buttonIcon = this.props.buttonIcon || (withIcon && iconTypes.complaintCircleAlmost);
    const { renderModal } = this.state;

    return (
      <>
        <Button
          {...bemClasses('btn', null, className)}
          title={buttonTitle}
          onClick={this.openModal}
          iconType={buttonIcon}
          label={buttonLabel}
          dataView={dataView}
          inListDD={inListDD}
        />
        {renderModal &&
          <ComplaintModal
            entity={entity}
            entityId={entityId}
            renderModal={renderModal}
            onClose={this.openModal}
            updateEvent={updateEvent}
            url={url}
          />
        }
      </>
    );
  }
}

export default Complaint;
